import { render, staticRenderFns } from "./ThreeLessContent.vue?vue&type=template&id=0a59ef16&scoped=true"
import script from "./ThreeLessContent.vue?vue&type=script&lang=js"
export * from "./ThreeLessContent.vue?vue&type=script&lang=js"
import style0 from "./ThreeLessContent.vue?vue&type=style&index=0&id=0a59ef16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a59ef16",
  null
  
)

export default component.exports